import { createModal } from '/@/core/elements/modal'

interface ViziDetailModalData {
  viziId: string | null
}

const { api, component } = createModal<ViziDetailModalData>(
  'ViziDetailModal',
  () => import('./ViziDetailModal.vue'),
  {
    viziId: null,
  },
)

export const useViziDetailModal = api
export default component
